// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"7492":"13d108d2","8056":"e9974904"}[chunkId] || chunkId) + "." + {"3481":"6c0bedccb2221115","4263":"626f47a3729e96bf","7492":"6abb7bd2e476e4fe","8056":"067e8033b1e4dd2d","8656":"4ccfd88c1e694e68"}[chunkId] + ".js";
};